import {
  dateFNS,
  fromTimeZoneToUTC,
  rangePresets,
  toISOString,
} from '@gogame/intl-ts';

export const SCREEN_NAME = 'home-dashboard';

export const FILTER_PRESETS = 'presets';
export const FILTER_PERIOD = 'period';

export const PRESETS_PERIOD = 'PRESETS_PERIOD';

export const USER_SETTINGS_SCREEN_NAME = 'home-dashboard';

const defaultDate = new Date(Date.now() + 24 * 60 * 60 * 1000);

export const VALUE_PRESETS_PERIOD = [
  dateFNS.startOfDay(defaultDate),
  dateFNS.endOfDay(defaultDate),
].map((date) => toISOString(fromTimeZoneToUTC(date)));

export const PERIOD_PRESETS = [
  {
    key: [PRESETS_PERIOD],
    label: `Preset's period`,
    value: VALUE_PRESETS_PERIOD,
  },
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_YEAR,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LIFETIME,
];
